module.exports = new __parcel__URL__("second_tab_content_zh-tw.afe7393f.webp").toString();